import { Avatar } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { useState, useEffect } from 'react';
import { getAccountDetails } from 'api/GoogleAuth';

export const UserAvatar = ({ size }) => {
  const userData = useSelector((state: RootState) => state.userData);
  const [accountData, setAccountData] = useState<any>(null);

  useEffect(() => {
    const fetchAccountData = async () => {
      if (!userData.apiKey || !userData.isUserLoggedIn) return;
      
      try {
        const response = await getAccountDetails(userData.apiKey);
        if (response.status === 'success') {
          setAccountData(response.data);
        }
      } catch (error) {
        // console.error('Error fetching avatar data:', error);
      }
    };

    fetchAccountData();
  }, [userData.apiKey, userData.isUserLoggedIn]);

  // Determine name and avatar
  const userName = accountData?.google_data?.given_name || 
                   accountData?.telegram_data?.username || 
                   userData.userNickname || 
                   'U';
  
  const avatarSrc = accountData?.google_data?.picture || userData.avatarUrl;

  return (
    <Avatar 
      size={size} 
      name={userName} 
      src={avatarSrc} 
      // Initials on the AA brand fill (purple.400 was 3.26:1 under white).
      background="brand.solid"
      color="brand.fg"
    />
  );
};
